import { sendMessage } from "../messaging/sender.js";

/** @deprecated */
export default {
	/**
	 * @example sendMessage<"blockTabs"> will enforce the params of sendMessage to require the compatible types
	 */
	sendMessage,
};
